module.exports = __webpack_public_path__ + "static/media/no-view.fb2b73ed.png";